import { combineReducers } from 'redux';
import BotReducer from './bot';
import CalendarReducer from './calendarBot';
import DiaryReducer from './diaryBot';
import HistoryReducer from './historyBot';
import MainReducer from './main';
import ManagerReducer from './manager';
import MessageReducer from './messageBot';
import PhotoReducer from './photoBot';
import PrivateReducer from './privateManager';
import RobotReducer from './robot';
import SubuserReducer from './subUser';
import SignupReducer from './signup';
import ProfileReducer from './profile';
import DashboardReducer from './dashboard';
import PicareDashboardReducer from './picareDashboard';

export default combineReducers({
  bot: BotReducer,
  calendarBot: CalendarReducer,
  diaryBot: DiaryReducer,
  historyBot: HistoryReducer,
  main: MainReducer,
  manager: ManagerReducer,
  messageBot: MessageReducer,
  photoBot: PhotoReducer,
  private: PrivateReducer,
  robot: RobotReducer,
  signup: SignupReducer,
  profile: ProfileReducer,
  subuser: SubuserReducer,
  dashboard: DashboardReducer,
  picareDashboard: PicareDashboardReducer,
});
